/**
 * @module Search
 */
import 'webpack-jquery-ui/autocomplete';

import Component from '../base/Component';
import Field from '../base/Field';
import './styles.css';

import '../../images/sprite/search.svg';
import '../../images/sprite/cross.svg';
import '../../images/sprite/close_sm.svg';

/**
 * Название компонента.
 */
export default class Search extends Component {
    static className = 'search-main';
}

function initSearchSuggest() {
    const staticData = !!(window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
    if ($('.js-search-suggest').length) {
        const $searchInput = $('#field-search');

        let isPopular = false;
        let isProducts = false;
        let searchData = [];
        let popularData = [];

        if (staticData) {
            popularData = require('../../json/json_popular.json');
        } else {
            $.ajax({
                url: `/api/internal/popular`,
                success(data) {
                    popularData = data.results;
                },
            });
        }

        const options = {
            delay: 100,
            source: (request, response) => {
                /* Игнорируем лишние пробелы в начале строки */
                const term = $.trim(request.term);
                async function getLocalSearchData() {
                    return require('../../json/json_items.json');
                }
                async function getActualSearchData() {
                    const data = await $.ajax({
                        url: `/api/internal/search/${term}`,
                    });
                    return data.results;
                }
                let searchDataPromise;
                if (staticData) {
                    searchDataPromise = getLocalSearchData();
                } else {
                    searchDataPromise = getActualSearchData();
                }
                let results;

                if (term != '') {
                    searchDataPromise.then(searchDataResults => {
                        searchData = searchDataResults;
                        results = searchDataResults.products;
                        response(results.slice(0, 3));
                    });
                } else {
                    results = popularData;
                    // Для популярных запросов
                    response(results.slice(0, 10));
                }
            },
            minLength: 0,
            search: () => {
                $('.js-search-suggest-container').empty();
            },
            response: (event, ui) => {
                const $searchContainer = $(event.target)
                    .closest('.js-search-suggest')
                    .find('.js-search-suggest-container');

                isProducts = ui.content.some(elem => {
                    return elem.type == 'product';
                });

                isPopular = ui.content.some(elem => {
                    return elem.type == 'popular';
                });

                // Делаем два отдельных списка под популярное и под товары
                if (isPopular) {
                    $searchContainer.append(
                        `                <div class="search-main__popular">
                        <div class="search-main__drop-header">
                                Популярные запросы
                        </div>
                        <ol class="search-main__drop-list">
                        </ol>
</div>`
                    );
                }

                if (isProducts) {
                    $searchContainer.append(
                        $(
                            `<div class="search-main__products"><a href="/search?query=${searchData.search_maybe}" class="search-main__drop-header search-main__drop-header--products">Искать «${searchData.search_maybe}»?</a><ol class="search-main__drop-list search-main__products-list"></ol>
                            <div class="search-main__drop-footer">
                            <button class="link link--white link--clear link--lwcs search-main__popular-clear js-clear-search"
                                    type="button">Очистить <svg class="icon icon--cross search-main__popular-clear-icon"><use xlink:href="#icon-cross"></use></svg>
                                    </button>
                    </div>
                            </div>`
                        )
                    );
                }
            },
        };

        $searchInput.each(function eachInput() {
            const $input = $(this);
            /* eslint no-underscore-dangle: 0 */
            $input.autocomplete(options).autocomplete('instance')._renderItemData = function rendItem($ul, item) {
                const $searchContainer = $input.closest('.js-search-suggest').find('.js-search-suggest-container');
                const $listProduct = $searchContainer.find('.search-main__drop-list');
                const $li = $(document.createElement('li'));
                $li.addClass('search-main__products-item');

                $searchContainer.addClass('is-visible');

                if (item.type === 'product') {
                    $li.addClass('search-main__products-item');
                    return $li
                        .html(
                            `<a href="/search?query=${item.name}"
                                            class="link link--clear link--lwcs search-main__products-item-link">
                                            <div class="search-main__products-img-wrapper">
                                                <picture class="picture picture--bg search-main__products-img">
                                                    <img class="picture__img lazyload" src="${item.pic}" alt="">
                                                </picture>
                                            </div>
                                            <p class="search-main__products-item-title">${item.name}
                                            <span class="search-main__products-item-price">${item.price}</span>
                                            </p>
                                    </a>`
                        )
                        .appendTo($listProduct);
                }

                if (item.type === 'popular') {
                    $li.addClass('search-main__popular-item');
                    return $li
                        .html(
                            `<a href="/search?query=${item.name}"
                                                    class="link link--clear link--lwcs search-main__popular-item-link">${item.name}</a>`
                        )
                        .appendTo($listProduct);
                }

                return true;
            };
        });

        $searchInput.on('keyup', e => {
            // скрываем блок подсказок при нажатии на Esc
            if (e.keyCode === 27) {
                $('.js-search-suggest-container').removeClass('is-visible');
            }
            // когда нет результатов, скрываем контейнер
            if (
                $('.js-search-suggest-container').is(':empty') &&
                $('.js-search-suggest-container').hasClass('is-visible')
            ) {
                $('.js-search-suggest-container').removeClass('is-visible');
            }

            checkFieldEmpty();
        });

        // скрываем блок подсказок при клике вне блока с формой
        $(document).on('mousedown', e => {
            if ($(e.target).closest('.js-search-suggest').length === 0) {
                $('.js-search-suggest-container').removeClass('is-visible');
            }
        });

        $(document).on('click', '.js-clear-search', () => {
            $searchInput.val('');
            checkFieldEmpty();
            $searchInput.focus();
        });

        $searchInput.on('focus', e => {
            /* Вручную запускаем поиск при фокусе на инпуте */
            $(e.target).autocomplete('search');
        });
    }
}

function checkFieldEmpty() {
    if (!$('#field-search').val()) {
        $('.js-search-clear').removeClass('is-active');
    } else {
        $('.js-search-clear').addClass('is-active');
    }
}

function initBtnClear() {
    $('.js-search-clear').appendTo('.js-search-field');
}

$(() => {
    Field.create();
    initSearchSuggest();
    initBtnClear();

    $(document).on('click', '.js-open-search', () => {
        $('.search-main').toggleClass('search-main--active');
        if ($('.menu-btn.is-open')) {
            $('.menu-btn.is-open').click();
        }
    });

    $('#search-main-form').submit(function() {
        const query = $('#field-search').val();
        $.ajax({
            url: `/api/internal/component/search:search.main`,
            method: 'post',
            data: {
                query,
            },
            success() {
                window.location.href = `/search?query=${query}`;
            },
        });
        return false;
    });
});
